import type { Router } from 'vue-router'

const CHUNK_RELOAD_KEY = 'app-chunk-reload'

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false
  const message = error instanceof Error ? error.message : String(error)
  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Loading chunk .* failed/i.test(message)
  )
}

export function reloadPageOnce(reason: 'chunk' | 'version'): void {
  const key = reason === 'chunk' ? CHUNK_RELOAD_KEY : 'app-version-reload'
  if (sessionStorage.getItem(key)) {
    sessionStorage.removeItem(key)
    console.error(`[appVersion] ${reason} reload already attempted, giving up`)
    return
  }
  sessionStorage.setItem(key, '1')
  window.location.reload()
}

export function setupChunkLoadRecovery(router: Router): void {
  router.onError((error) => {
    if (!isChunkLoadError(error)) return
    console.warn('[appVersion] Chunk load failed, reloading page...', error)
    reloadPageOnce('chunk')
  })

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    console.warn('[appVersion] Vite preload error, reloading page...')
    reloadPageOnce('chunk')
  })
}
